export default "__VITE_ASSET__CB8AuMfa__"